<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    class="fill-current inline"
    :class="[width, height]"
    viewBox="0 0 16 16"
  >
    <defs>
      <clipPath id="clip-path">
        <rect width="16" height="16" fill="none" />
      </clipPath>
    </defs>
    <g id="Component_1" data-name="Component 1" clip-path="url(#clip-path)">
      <rect id="Rectangle_117" data-name="Rectangle 117" width="16" height="16" fill="none" />
      <path
        id="Path_50"
        data-name="Path 50"
        d="M14,2H2L8,7ZM0,2A2.006,2.006,0,0,1,2,0H14a2.006,2.006,0,0,1,2,2v8a2.006,2.006,0,0,1-2,2H2a2.006,2.006,0,0,1-2-2Z"
        transform="translate(0 2)"
        fill="#f0324c"
        fill-rule="evenodd"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: 'w-4'
    },
    height: {
      type: String,
      default: 'h-4'
    }
  }
}
</script>
